import { z } from 'zod';
import { ERROR_CODES } from '../registries/errors.ts';

export const ErrorCodeSchema = z.enum(ERROR_CODES);

/** Body of every non-2xx API response. */
export const ApiErrorBody = z.object({
  error: z.object({
    code: ErrorCodeSchema,
    /** Diagnostic text for logs; never shown to people. */
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;
